const pointer = {
  mouse: '@media (hover: hover)',
  touch: '@media (pointer: coarse)',
};

export default pointer;
